import React from 'react';

const TractionSection = () => {
  return (
    <section className="relative bg-gradient-to-b from-gray-50 to-white py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-6">
        {/* Title */}
        <div className="mb-12 text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-2">
            Loved by users.{' '}
            <span className="bg-gradient-to-r from-emerald-600 to-teal-600 bg-clip-text text-transparent">Instantly familiar.</span>
          </h2>
          <p className="text-2xl md:text-3xl text-gray-500 font-light mt-2">
            Privacy, without changing how you work.
          </p>
        </div>

        {/* Metrics Row */}
        <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-4">
          
          {/* Metric 1: Trusted by users */}
          <div className="flex items-center gap-4 bg-white rounded-full px-6 py-4 shadow-sm border border-gray-100">
            {/* Pixelated User Avatars - Horizontal block style */}
            <div className="flex -space-x-3">
              {/* Avatar 1 */}
              <div className="w-10 h-10 rounded-full border-2 border-white overflow-hidden flex flex-col">
                <div className="flex-1 flex">
                  <div className="flex-1 bg-emerald-300"></div>
                  <div className="flex-1 bg-emerald-400"></div>
                  <div className="flex-1 bg-emerald-300"></div>
                </div>
                <div className="flex-1 flex">
                  <div className="flex-1 bg-emerald-400"></div>
                  <div className="flex-1 bg-emerald-200"></div>
                  <div className="flex-1 bg-emerald-400"></div>
                </div>
                <div className="flex-1 flex">
                  <div className="flex-1 bg-emerald-300"></div>
                  <div className="flex-1 bg-emerald-400"></div>
                  <div className="flex-1 bg-emerald-300"></div>
                </div>
              </div>
              
              {/* Avatar 2 */}
              <div className="w-10 h-10 rounded-full border-2 border-white overflow-hidden flex flex-col">
                <div className="flex-1 flex">
                  <div className="flex-1 bg-gray-100"></div>
                  <div className="flex-1 bg-gray-800"></div>
                  <div className="flex-1 bg-gray-100"></div>
                </div>
                <div className="flex-1 flex">
                  <div className="flex-1 bg-gray-800"></div>
                  <div className="flex-1 bg-gray-200"></div>
                  <div className="flex-1 bg-gray-800"></div>
                </div>
                <div className="flex-1 flex">
                  <div className="flex-1 bg-gray-100"></div>
                  <div className="flex-1 bg-gray-800"></div>
                  <div className="flex-1 bg-gray-100"></div>
                </div>
              </div>
              
              {/* Avatar 3 */}
              <div className="w-10 h-10 rounded-full border-2 border-white overflow-hidden flex flex-col">
                <div className="flex-1 flex">
                  <div className="flex-1 bg-teal-200"></div>
                  <div className="flex-1 bg-teal-400"></div>
                  <div className="flex-1 bg-teal-200"></div>
                </div>
                <div className="flex-1 flex">
                  <div className="flex-1 bg-teal-400"></div>
                  <div className="flex-1 bg-teal-300"></div>
                  <div className="flex-1 bg-teal-400"></div>
                </div>
                <div className="flex-1 flex">
                  <div className="flex-1 bg-teal-200"></div>
                  <div className="flex-1 bg-teal-400"></div>
                  <div className="flex-1 bg-teal-200"></div>
                </div>
              </div>
              
              {/* Avatar 4 */}
              <div className="w-10 h-10 rounded-full border-2 border-white overflow-hidden flex flex-col">
                <div className="flex-1 flex">
                  <div className="flex-1 bg-lime-300"></div>
                  <div className="flex-1 bg-lime-400"></div>
                  <div className="flex-1 bg-lime-300"></div>
                </div>
                <div className="flex-1 flex">
                  <div className="flex-1 bg-lime-400"></div>
                  <div className="flex-1 bg-lime-200"></div>
                  <div className="flex-1 bg-lime-400"></div>
                </div>
                <div className="flex-1 flex">
                  <div className="flex-1 bg-lime-300"></div>
                  <div className="flex-1 bg-lime-400"></div>
                  <div className="flex-1 bg-lime-300"></div>
                </div>
              </div>
              
              {/* Avatar 5 - More users indicator */}
              <div className="w-10 h-10 rounded-full border-2 border-white bg-gray-100 flex items-center justify-center">
                <span className="text-xs font-semibold text-gray-600">+50k</span>
              </div>
            </div>
            
            {/* Text */}
            <div>
              <p className="text-gray-900 font-semibold text-sm md:text-base">
                Chosen by over <span className="text-emerald-600">50k</span> users
              </p>
              <p className="text-gray-500 text-xs">
                anonymous
              </p>
            </div>
          </div>

          {/* Divider */}
          <div className="hidden md:block w-px h-12 bg-gray-200"></div>

          {/* Metric 2: Google Ranking */}
          <div className="flex items-center gap-4 bg-white rounded-full px-6 py-4 shadow-sm border border-gray-100">
            {/* Google Logo */}
            <div className="w-10 h-10 flex items-center justify-center">
              <svg viewBox="0 0 24 24" className="w-8 h-8">
                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
              </svg>
            </div>
            
            {/* Text */}
            <div>
              <p className="text-gray-900 font-semibold text-sm md:text-base">
                Ranked on Google
              </p>
              <p className="text-gray-500 text-xs">
                for "<span className="text-emerald-600 font-medium">Text Transfer</span>"
              </p>
            </div>
          </div>

          {/* Divider */}
          <div className="hidden md:block w-px h-12 bg-gray-200"></div>

          {/* Metric 3: Uptime */}
          <div className="flex items-center gap-4 bg-white rounded-full px-6 py-4 shadow-sm border border-gray-100">
            {/* Certification Checkmark Icon */}
            <div className="w-10 h-10 flex items-center justify-center">
              <div className="relative">
                {/* Shield/Badge shape */}
                <svg className="w-9 h-9" viewBox="0 0 40 40" fill="none">
                  {/* Outer shield */}
                  <path 
                    d="M20 2L4 8v12c0 9.55 6.8 18.48 16 20.5 9.2-2.02 16-10.95 16-20.5V8L20 2z" 
                    fill="url(#shieldGradient)"
                    stroke="#059669"
                    strokeWidth="1.5"
                  />
                  {/* Checkmark */}
                  <path 
                    d="M14 20l4 4 8-8" 
                    stroke="white" 
                    strokeWidth="3" 
                    strokeLinecap="round" 
                    strokeLinejoin="round"
                  />
                  <defs>
                    <linearGradient id="shieldGradient" x1="4" y1="2" x2="36" y2="40" gradientUnits="userSpaceOnUse">
                      <stop stopColor="#10b981"/>
                      <stop offset="1" stopColor="#059669"/>
                    </linearGradient>
                  </defs>
                </svg>
              </div>
            </div>
            
            {/* Text */}
            <div>
              <p className="text-gray-900 font-semibold text-sm md:text-base">
                <span className="text-emerald-600">99.99%</span> uptime
              </p>
              <p className="text-gray-500 text-xs">
                worldwide
              </p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default TractionSection;
